export default __webpack_public_path__ + "static/media/crmlogo.7904565d.png";